import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=76ab09b2&lang=pug"
import script from "./PageLayout.vue?vue&type=script&lang=ts"
export * from "./PageLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports